import React, { useEffect, useState } from 'react'
import { BtnIcon, CustomCard, CustomDataTableHeader, SectionTitle } from '../../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../../assets/js/styles'
import { azul } from '../../../../../assets/js/colors'
import { connect } from 'react-redux'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import { errorHandler } from '../../../../../services/util/error.service'
import ModalCicloAlteracaoQuantidade from './ModalCicloAlteracaoQuantidade'
import CicloEntregaAcoesHttp from '../../../../../services/api/https/deliveries/ciclo-entrega-acoes.http'

function CicloAlteracaoQuantidades({ ciclo, dispatch }) {
  const [globalFilter, setGlobalFilter] = useState('')
  const [selectedDeliveriesItems, setSelectedDeliveriesItems] = useState([])
  const [deliveries, setDeliveries] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [totalCaixas, setTotalCaixas] = useState(0)

  useEffect(() => {
    fetchEntregas()
  }, [])

  // Helpers
  const fetchEntregas = () => {
    CicloEntregaAcoesHttp.getEntregasByCicloId(ciclo.id)
      .then(d => {
        setTotalCaixas(d.reduce((total, item) => total + item.qteSKU, 0))
        setDeliveries(d)
        setIsLoading(false)
        setSelectedDeliveriesItems([])
      })
      .catch(e => {
        setIsLoading(false)
        dispatch(showMessageBox(null, errorHandler(e)))
      })
  }
  // Events
  const onBtnItemClick = async item => {
    try {
      dispatch(showLoadingBox('Carregando os Produtos . . . ', 'Aguarde'))
      const { delivery_id } = item
      const items = await CicloEntregaAcoesHttp.getDeliveryItemsByDeliveryId(delivery_id)
      setSelectedDeliveriesItems(items)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    } finally {
      dispatch(hideLoadingBox())
    }
  }

  // Render
  return (
    <>
      <div className="p-grid">
        <div className="p-col-12">
          <SectionTitle title="Alteração de Quantidade" />
        </div>
        <div className="p-col-3">
          <CustomCard
            title={'Quantidade Total de Caixas'}
            subTitle={'Soma de todas as notas'}
            valueStyle={{ color: azul, fontSize: '1.3rem', fontWeight: 600 }}
          >
            {totalCaixas}
          </CustomCard>
        </div>
        <div className="p-col-12">
          <DataTable
            header={<CustomDataTableHeader onChange={setGlobalFilter} />}
            globalFilter={globalFilter}
            value={deliveries}
            emptyMessage="Não existe Entrega associada a este Ciclo"
            rows={10}
            paginator
            loading={isLoading}
          >
            <Column field="client_fantasia" header="Cliente" />
            <Column sortable field="city_name" header="Cidade" />
            <Column sortable field="district" header="Bairro" style={tableCellCentered(150)} />
            <Column
              sortable
              field={'identifier'}
              header="Identificador"
              style={tableCellCentered(200)}
            />
            <Column field="qteSKU" header="Qte Sku" style={tableCellCentered()} />
            <Column
              header=""
              style={tableCellCentered(80)}
              body={item => (
                <BtnIcon onClick={() => onBtnItemClick(item)}>
                  <i className="pi pi-arrow-right" style={{ color: azul }} />
                </BtnIcon>
              )}
            />
          </DataTable>
        </div>
      </div>
      <ModalCicloAlteracaoQuantidade
        deliveryItems={selectedDeliveriesItems}
        visible={selectedDeliveriesItems.length > 0}
        onResponse={(action, payload) => {
          if (action === 'close') setSelectedDeliveriesItems([])
          if (action === 'success') {
            fetchEntregas()
          }
          if (action === 'error') dispatch(showMessageBox(null, payload))
        }}
      />
    </>
  )
}

export default connect()(CicloAlteracaoQuantidades)
